import Component from "vue-class-component";

Component.registerHooks([
    "validations",
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate"
]);
